var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F34747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71973 9.21484V14.4993H6.27246V13.0564H7.02686C8.26099 13.0564 9.09961 12.3057 9.09961 11.1411C9.09961 9.96558 8.30859 9.21484 7.13306 9.21484H4.71973ZM6.27246 10.3867H6.71924C7.22461 10.3867 7.53223 10.6431 7.53223 11.1448C7.53223 11.6501 7.22461 11.9065 6.70825 11.9065H6.27246V10.3867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0591 9.21484V14.4993H12.4028C13.9995 14.4993 14.8674 13.5471 14.8674 11.7893C14.8674 10.1377 13.9812 9.21484 12.4028 9.21484H10.0591ZM11.6118 10.4453H12.0989C12.8459 10.4453 13.2854 10.9287 13.2854 11.8186C13.2854 12.7927 12.8752 13.2688 12.0989 13.2688H11.6118V10.4453Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.376 14.4993V12.6279H19.3315V11.4634H17.376V10.4453H19.5366V9.21484H15.8232V14.4993H17.376Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.9f3cb0a8d08a197664c3e9900d6d4357.svg";
export { ForwardRef as ReactComponent };